export default {
    edit: "Edytuj",
    location: "Lokalizacja + T&C",
    filter: "Filtr"
}



// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/lang/pl/quotes/header.js